import React, { useEffect, useRef, useState } from 'react';

// Brand logos data with actual images - Add more logos here
const brandsData = [
  { 
    id: 1, 
    name: 'Cacao Springs', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/g5dclnyl_Cacao%20springs%20logooo.jpg'
  },
  { 
    id: 2, 
    name: 'Corridor Seven Coffee', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/0sy6xylv_Corridor%207%20logo.png'
  },
  { 
    id: 3, 
    name: 'India TV', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/x0ijkboa_India%20tv%20logo.png'
  },
  { 
    id: 4, 
    name: 'Kalone', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/gyy1b7oo_Kalone%20logo.jpg'
  },
  { 
    id: 5, 
    name: 'The Souled Store', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/56ldronw_the%20souled%20store%20logo.png'
  },
  { 
    id: 6, 
    name: 'Torero', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/w6zbaegb_torero_corp_logo.jpg'
  },
  { 
    id: 7, 
    name: 'UFO Cine Media', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/43ar4nla_UFO%20logo.jpg'
  },
  { 
    id: 8, 
    name: 'UPL', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/9urxuii1_UPL%20logo.png'
  },
  { 
    id: 9, 
    name: 'Whiskas', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/5pjr16zu_Whiskas-logo.png'
  },
  { 
    id: 11, 
    name: 'One Science', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/tfw3fofu_One%20science%20logo.png'
  },
  { 
    id: 12, 
    name: 'Pedigree', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/983nuze0_Pedigree%20Red%20Rosette%20Core%20Digital%20RGB_BG_2.png'
  },
  { 
    id: 13, 
    name: 'Shaze', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/ksquqefa_Shaze%20logo.png'
  },
  { 
    id: 14, 
    name: 'Spotify', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/ppejl9a7_Spotify%20logo.png'
  },
  { 
    id: 15, 
    name: 'Laxmipati Sarees', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/z5osvl11_Laxmipati%20sarees%20logo.jpg'
  },
  { 
    id: 16, 
    name: 'Audi', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/ft2twubd_Logo-Audi.png'
  },
  { 
    id: 17, 
    name: 'Audible', 
    logo: 'https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/bcr2kchc_Audible%20logo.png'
  },
  { 
    id: 18, 
    name: 'Novotel', 
    logo: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/3c0coyao_novotel.png'
  },
  { 
    id: 19, 
    name: 'XYXX', 
    logo: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/qs1ul6it_XYXX%20-%20logo%20-%20png.png'
  },
  { 
    id: 20, 
    name: 'S Cube', 
    logo: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/wk4hc8ms_s%20cube.png'
  },
  { 
    id: 21, 
    name: 'Cinépolis', 
    logo: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/r120g411_Cin%C3%A9polis.svg.png'
  },
  { 
    id: 22, 
    name: 'Kingdom of White', 
    logo: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/l5b3iaez_Knigdom%20of%20white.jpg'
  },
];

const BrandsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const sectionRef = useRef(null);
  const scrollRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Auto-scroll using JavaScript
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const autoScroll = () => {
      if (!isPaused && !isDragging && scrollContainer) {
        scrollContainer.scrollLeft += 1;
        
        // Reset to start when reaching the end (for seamless loop)
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        if (scrollContainer.scrollLeft >= maxScroll - 1) {
          scrollContainer.scrollLeft = 0;
        }
      }
      animationRef.current = requestAnimationFrame(autoScroll);
    };

    animationRef.current = requestAnimationFrame(autoScroll);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPaused, isDragging]);

  // Drag handlers
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    setIsPaused(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  // Touch handlers for mobile
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  // Duplicate logos for seamless infinite scroll
  const duplicatedBrands = [...brandsData, ...brandsData, ...brandsData];

  return (
    <section ref={sectionRef} className="py-24 bg-[#F5FDFF] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 border border-[#00C4CC]/20 rounded-full" />
      <div className="absolute bottom-20 right-10 w-48 h-48 border border-[#00E08F]/20 rounded-full" />

      <div className="relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 px-4">
          <h2
            className={`text-3xl md:text-4xl font-bold text-[#04101C] mb-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Brands That <span className="bg-gradient-to-r from-[#00C4CC] to-[#00E08F] bg-clip-text text-transparent">Trust Us</span>
          </h2>
          <p
            className={`text-[#04101C]/60 max-w-xl mx-auto transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Trusted by leading brands to bring their podcast vision to life.
          </p>
        </div>

        {/* Auto-scrolling Marquee with Drag */}
        <div 
          className={`relative overflow-hidden transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Gradient Fade Left */}
          <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#F5FDFF] to-transparent z-10 pointer-events-none" />
          
          {/* Gradient Fade Right */}
          <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#F5FDFF] to-transparent z-10 pointer-events-none" />

          {/* Scrolling Container */}
          <div 
            ref={scrollRef}
            className={`flex overflow-x-auto scrollbar-hide select-none ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={handleMouseLeave}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
          >
            {duplicatedBrands.map((brand, index) => (
              <div
                key={`${brand.id}-${index}`}
                className="flex-shrink-0 mx-4"
                draggable={false}
              >
                <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 w-48 h-36 flex items-center justify-center p-4 border border-gray-100 hover:border-[#00C4CC]/50">
                  <img 
                    src={brand.logo} 
                    alt={brand.name}
                    className="max-w-full max-h-full w-auto h-auto object-contain group-hover:scale-105 transition-transform duration-300 pointer-events-none"
                    draggable={false}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>
  );
};

export default BrandsSection;
